import React from 'react';

export type ToastKey = string;

export interface ToastItemOpts {
  id?: ToastKey;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration?: number;
  isClosable?: boolean;
}

export interface ToastProviderOpts {
  enqueueToast: (opts: ToastItemOpts) => ToastKey;
}

export const ToastProviderContext = React.createContext<ToastProviderOpts>(
  {} as ToastProviderOpts
);
